import { render, staticRenderFns } from "./SummaryDetails.vue?vue&type=template&id=6c31bfe2"
import script from "./SummaryDetails.vue?vue&type=script&lang=js"
export * from "./SummaryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports